// Redux action types
export const SET = 'one-state-subject/set';
export const ADD = 'one-state-subject/add';
export const SETSELECTED = 'one-state-subject/setselected';
export const SETPATIENTSELECTED = 'one-state-subject/set-patient-selected';
export const REINIT = 'one-state-subject/reinit';
export const RESET = 'one-state-subject/reset';
export const CALLERPROVIDER = 'caller-provider';
export const NO_CHANGE = 'one-state-subject/no-change';